import { Box, Typography, SxProps, Theme } from '@mui/material';
import { useContext } from 'react';
import StoreContext from 'contexts/storeContext';
import { GREEN_BP } from 'theme';
import { formatUnitAndValue } from 'utils';
import DashboardDescription from 'components/Dashboard/DashboardDescription';

type Props = {
  label: string;
  value: number;
  unit: string;
  sx?: SxProps<Theme>;
  boxSx?: SxProps<Theme>;
};

export const DashboardBigNumber = ({ label, value, unit, sx, boxSx }: Props) => {
  const { formatNumber } = useContext(StoreContext);

  return (
    <Box
      sx={{
        minWidth: 180,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        my: 1,
        mx: 3,
        ...boxSx,
      }}
    >
      <DashboardDescription>{label}</DashboardDescription>
      <Typography sx={{ fontWeight: 'bold', fontSize: '1.8rem', color: GREEN_BP, textAlign: 'center', ...sx }}>
        {formatUnitAndValue(unit, formatNumber(value))}
      </Typography>
    </Box>
  );
};
